import React, { useEffect, useRef, useState } from "react";
import "./VisaQuotePrint.scss";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { useParams } from "react-router-dom";
import { getVisaQuotationByID } from "../services/quotation.services";
import moment from "moment";
import IconComponent from "../../../components/common/IconComponent";
import { IoIosMail } from "react-icons/io";
import { MdCall, MdOutgoingMail, MdPrint } from "react-icons/md";
import { TbWorldWww } from "react-icons/tb";
import { FaLocationDot } from "react-icons/fa6";
import { formatIndianNumber } from "../../../_helper/helper";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { API_URL } from "../../../app/config";
import { LoadingPanel } from "../../../components/layout/Loading";
import {
  getLocalAccessToken,
  getLocalWebsiteHeader,
} from "../../../app/getTokens";
import { axiosApiInstance } from "../../../app/axios";
import { FaFilePdf } from "react-icons/fa";
import NoDataFoundPage from "../../../components/common/NoDataFoundPage";

const VisaQuotePrint: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const params = useParams();
  const VisaQuot_GUID = params?.VisaQuot_GUID;
  const loading = useAppSelector((state) => state.quotation.loading);
  const VisaQuotationDetail = useAppSelector(
    (state) => state.quotation.VisaQuotationDetail,
  );

  const [emailLoading, setEmailLoading] = useState(false);
  const [PDFLoading, setPDFLoading] = useState(false);

  useEffect(() => {
    if (VisaQuot_GUID) {
      dispatch(getVisaQuotationByID({ VisaQuot_GUID: VisaQuot_GUID }));
    }
  }, [VisaQuot_GUID]);

  // const quoteData: QuoteData = {
  //   id: "VQ-2024-001",
  //   clientName: "John Smith",
  //   email: "john.smith@email.com",
  //   phone: "+1 (555) 987-6543",
  //   nationality: "United States",
  //   destination: "United Kingdom",
  //   visaType: "Tourist Visa",
  //   duration: "6 Months",
  //   travelDate: "March 15, 2024",
  //   processingType: "Standard (15-20 days)",
  //   services: [
  //     {
  //       description: "UK Tourist Visa Processing",
  //       quantity: "1",
  //       unitPrice: "$150.00",
  //       totalPrice: "$150.00",
  //     },
  //     {
  //       description: "Document Review & Verification",
  //       quantity: "1",
  //       unitPrice: "$75.00",
  //       totalPrice: "$75.00",
  //     },
  //     {
  //       description: "Application Form Assistance",
  //       quantity: "1",
  //       unitPrice: "$50.00",
  //       totalPrice: "$50.00",
  //     },
  //     {
  //       description: "Appointment Booking Service",
  //       quantity: "1",
  //       unitPrice: "$25.00",
  //       totalPrice: "$25.00",
  //     },
  //     {
  //       description: "Express Document Courier",
  //       quantity: "1",
  //       unitPrice: "$40.00",
  //       totalPrice: "$40.00",
  //     },
  //   ],
  //   subtotal: "$340.00",
  //   serviceTax: "$27.20",
  //   processingFee: "$15.00",
  //   totalAmount: "$382.20",
  // };

  const handleSendEmail = async (VisaQuot_GUID: string) => {
    try {
      setEmailLoading(true);
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaQuotation/DynamicGetVisaQuotationPDF`,
        { VisaQuot_GUID: VisaQuot_GUID },
      );
      if (response.status === 200) {
        SuccessToast("Email Sent Successfully!");
      } else {
        ErrorToast("Failed to Send Email!");
      }
    } catch (error) {
      console.error("Download error:", error);
      ErrorToast("Failed to sending Quotation! - Please try again later");
    } finally {
      setEmailLoading(false);
    }
  };

  const handleQuotationDownload = async (VisaQuot_GUID: string) => {
    const token = getLocalAccessToken();
    const website = getLocalWebsiteHeader();
    try {
      setPDFLoading(true);

      const response = await fetch(
        `${API_URL}/VisaQuotation/DynamicDownloadGetVisaQuotationPDF`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
            URL: website,
          },
          body: JSON.stringify({
            VisaQuot_GUID: VisaQuot_GUID,
          }),
        },
      );

      if (!response.ok) {
        ErrorToast("Failed to generate PDF! - Please try after some time");
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }

      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `Visa Processing Quotation.pdf`;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      ErrorToast("Failed to download Quotation! - Please try again later");
    } finally {
      setPDFLoading(false);
    }
  };

  if (loading) return <LoadingPanel gridRef={gridRef} />;

  return (
    <>
      {(emailLoading || PDFLoading) && <LoadingPanel gridRef={gridRef} />}
      {VisaQuotationDetail?.ID ? (
        <div className="print-container">
          <div className="header">
            <div className="company-info">
              <div className="logo-section">
                {VisaQuotationDetail?.CompanyInfo &&
                  VisaQuotationDetail?.CompanyInfo?.CompanyLogo && (
                    <img
                      src={
                        VisaQuotationDetail?.CompanyInfo &&
                        VisaQuotationDetail?.CompanyInfo?.CompanyLogo
                          ? VisaQuotationDetail?.CompanyInfo?.CompanyLogo
                          : ""
                      }
                      alt="Company Logo"
                      className="company-logo"
                    />
                  )}
                <h1>
                  {VisaQuotationDetail?.CompanyInfo &&
                  VisaQuotationDetail?.CompanyInfo?.CompanyName
                    ? VisaQuotationDetail?.CompanyInfo?.CompanyName
                    : "AICRM Travel"}
                </h1>
              </div>
              <div className="contact-info">
                {VisaQuotationDetail?.CompanyInfo?.EmailID && (
                  <div>
                    <IconComponent icon={IoIosMail} />{" "}
                    {VisaQuotationDetail?.CompanyInfo?.EmailID}
                  </div>
                )}
                {VisaQuotationDetail?.CompanyInfo?.MobileNo && (
                  <div>
                    <IconComponent icon={MdCall} style={{ color: "red" }} />{" "}
                    {VisaQuotationDetail?.CompanyInfo?.MobileNo}
                  </div>
                )}
                <div>
                  <IconComponent
                    icon={TbWorldWww}
                    style={{ color: "#20c4f3" }}
                  />{" "}
                  www.aicrmtravel.com
                </div>
                {VisaQuotationDetail?.CompanyInfo?.Address && (
                  <div>
                    <IconComponent
                      icon={FaLocationDot}
                      style={{ color: "red" }}
                    />{" "}
                    {VisaQuotationDetail?.CompanyInfo?.Address}
                  </div>
                )}
                {VisaQuotationDetail?.CompanyInfo?.GSTNo && (
                  <div>GSTIN: {VisaQuotationDetail?.CompanyInfo?.GSTNo}</div>
                )}
              </div>
            </div>
            <div className="quote-title">VISA PROCESSING QUOTE</div>
          </div>

          <div className="content">
            <div className="quote-details">
              <div className="detail-section">
                <h3>Client Information</h3>
                <div className="detail-item">
                  <span className="detail-label">Quote ID:</span>
                  <span className="detail-value">
                    {VisaQuotationDetail?.QuotationNo}
                  </span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Client Name:</span>
                  <span className="detail-value">
                    {VisaQuotationDetail?.Initial}{" "}
                    {VisaQuotationDetail?.FirstName}{" "}
                    {VisaQuotationDetail?.LastName}
                  </span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Email:</span>
                  <span className="detail-value">
                    {VisaQuotationDetail?.EmailID}
                  </span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Phone:</span>
                  <span className="detail-value">
                    {VisaQuotationDetail?.MobileNo}
                  </span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Nationality:</span>
                  <span className="detail-value">
                    {VisaQuotationDetail?.Nationality}
                  </span>
                </div>
              </div>

              <div className="detail-section">
                <h3>Travel Details</h3>
                <div className="detail-item">
                  <span className="detail-label">Destination:</span>
                  <span className="detail-value">
                    {VisaQuotationDetail?.VisaCountry}
                  </span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Visa Type:</span>
                  <span className="detail-value fw-bold">
                    {VisaQuotationDetail?.VisaCategory}
                  </span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Duration:</span>
                  <span className="detail-value">
                    {VisaQuotationDetail?.Duration || 0} Days
                  </span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Travel Date:</span>
                  <span className="detail-value">
                    {VisaQuotationDetail?.TravelDate
                      ? moment(VisaQuotationDetail?.TravelDate).format(
                          "DD/MM/YYYY",
                        )
                      : ""}
                  </span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Processing Type:</span>
                  <span className="detail-value">
                    {VisaQuotationDetail?.ProcessingOption}
                  </span>
                </div>
              </div>
            </div>

            <table className="services-table">
              <thead>
                <tr>
                  <th>Service Description</th>
                  {/* <th>Quantity</th>
              <th>Unit Price</th> */}
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Visa Charges</td>
                  <td className="price text-end">
                    {formatIndianNumber(VisaQuotationDetail?.VisaCost || 0)}
                  </td>
                </tr>
                <tr>
                  <td>Processing Fee</td>
                  <td className="price text-end">
                    {formatIndianNumber(
                      VisaQuotationDetail?.ProcessionOptionAmount || 0,
                    )}
                  </td>
                </tr>
                {VisaQuotationDetail?.AdditionalServices &&
                  VisaQuotationDetail?.AdditionalServices?.length > 0 &&
                  VisaQuotationDetail?.AdditionalServices?.map(
                    (service, index) => (
                      <tr key={index}>
                        <td>{service.ServiceDescription}</td>
                        <td className="price text-end">
                          {formatIndianNumber(service.Price || 0)}
                        </td>
                      </tr>
                    ),
                  )}
                <tr style={{ borderTop: "2px solid red" }} className="fw-bold">
                  <td>Total Amount</td>
                  <td className=" text-end">
                    {formatIndianNumber(
                      +(VisaQuotationDetail?.VisaCost || 0) +
                        +(
                          VisaQuotationDetail?.TotalAdditionalServicesPrice || 0
                        ) +
                        +(VisaQuotationDetail?.ProcessionOptionAmount || 0),
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
            {/* <div className="total-section">
            <div className="total-row">
              <span>Subtotal:</span>
              <span className="price">
                {formatIndianNumber(
                  VisaQuotationDetail?.TotalAdditionalServicesPrice || 0
                )}
              </span>
            </div>
            <div className="total-row">
              <span>Processing Fee:</span>
              <span className="price">
                {formatIndianNumber(
                  VisaQuotationDetail?.ProcessionOptionAmount || 0
                )}
              </span>
            </div>
            <div className="total-row final">
              <span>Total Amount:</span>
              <span className="price">
                {formatIndianNumber(
                  (VisaQuotationDetail?.TotalAdditionalServicesPrice || 0) +
                    (VisaQuotationDetail?.ProcessionOptionAmount || 0)
                )}
              </span>
            </div>
          </div> */}

            {VisaQuotationDetail?.TermsAndCondition && (
              <div className="terms-section">
                <h4>Terms & Conditions</h4>
                <div
                  dangerouslySetInnerHTML={{
                    __html: VisaQuotationDetail?.TermsAndCondition,
                  }}
                />
              </div>
            )}

            <div className="action-buttons printbuttons">
              <button
                className="btn btn-primary"
                onClick={() => window.print()}
              >
                <IconComponent icon={MdPrint} className="fs-5" /> Print Quote
              </button>
              <button
                className="btn btn-success"
                onClick={() =>
                  handleSendEmail(
                    VisaQuotationDetail?.VisaQuot_GUID
                      ? VisaQuotationDetail?.VisaQuot_GUID
                      : "",
                  )
                }
              >
                <IconComponent icon={MdOutgoingMail} className="fs-5" /> Send
                Email
              </button>
              <button
                className="btn btn-secondary"
                onClick={() =>
                  handleQuotationDownload(
                    VisaQuotationDetail?.VisaQuot_GUID
                      ? VisaQuotationDetail?.VisaQuot_GUID
                      : "",
                  )
                }
              >
                <IconComponent icon={FaFilePdf} className="fs-6" /> Download PDF
              </button>
            </div>
          </div>

          <div className="footer">
            <p>
              Thank you for choosing{" "}
              {VisaQuotationDetail?.CompanyInfo &&
              VisaQuotationDetail?.CompanyInfo?.CompanyName
                ? VisaQuotationDetail?.CompanyInfo?.CompanyName
                : "AICRM Travel"}{" "}
              for your visa processing needs!
            </p>
            <p style={{ marginTop: "10px", fontSize: "14px", opacity: 0.9 }}>
              Quote generated on:{" "}
              {moment(VisaQuotationDetail?.CreatedOn).format("DD/MM/YYYY")} |
              Valid until:{" "}
              {moment(VisaQuotationDetail?.ExpiryDate).format("DD/MM/YYYY")}
            </p>
          </div>
        </div>
      ) : (
        <NoDataFoundPage />
      )}
    </>
  );
};

export default VisaQuotePrint;
